import CustomStore from "devextreme/data/custom_store";
import { apiConfiguration } from "../apiConfig";
import { AnagraficheComuniApi } from "../data/apis";
import { useContext, useMemo } from "react";
import TenantContext from "../contexts/tenantContext";

export function useProvinceDataSource(nazioneId: string | undefined, regioneId: string | undefined) {
    const api = new AnagraficheComuniApi(apiConfiguration);

    const dataSource = useMemo(() => {   
        return new CustomStore({
          key: "id",
          loadMode: 'raw',
          load: (loadOptions) => {
            if (nazioneId && regioneId)
              return api.getProvince({ nazioneId: nazioneId, regioneId: regioneId });
            else
              return [];
          },

          byKey: (key) => {
            return api.getProvinciaById({
                provinciaId: key
            });
          }
        });
      }, [nazioneId, regioneId]);

      return dataSource;
}


